export default __webpack_public_path__ + "static/media/Private.2b79bfe8.jpeg";